import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';

const initialStateElectrician = {
    Electrician: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getElectrician = createAsyncThunk(
    'electrician/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
              const getuserId = localStorage.getItem("id");

            const response = await axiosInstance.get(BASE_URL + '/getAllElectrician/'+getuserId, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.electrician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addElectrician = createAsyncThunk(
    'electrician/add',
    async (data, { dispatch, rejectWithValue }) => {
        // console.log(data, "data=====");
        try {
            const { electricianImage, MultipleImages, electricianDetails, ...rest } = data;
            const formData = new FormData();

            formData.append('MultipleImages', JSON.stringify(MultipleImages));

            if (Array.isArray(electricianDetails) && electricianDetails.length > 0) {
                electricianDetails.forEach((detail, index) => {
                    const formattedDetail = formatElectricianDetail(detail);
                    Object.keys(formattedDetail).forEach(key => {
                        if (formattedDetail[key] !== null && formattedDetail[key] !== '') {
                            formData.append(`electricianDetails[${index}][${key}]`, formattedDetail[key]);
                        }
                    });
                });
            } else {
                formData.append('electricianDetails', null);
            }

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (electricianImage) {
                electricianImage.forEach((file, index) => {
                    if (file instanceof File) {
                        formData.append('electricianImage', file);
                        formData.append(`electricianImageIndex_${formData.getAll('electricianImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        formData.append(`ExistingelectricianImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.post(BASE_URL + '/createElectrician', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            await dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data, "response.data.electrician");
            await dispatch(getElectrician());
            return response.data.electrician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteElectrician = createAsyncThunk(
    'electrician/delete',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id);
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteElectrician/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getElectrician());
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getElectricianById = createAsyncThunk(
    'electrician/view',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id, "id");
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getElectricianById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            console.log(response.data, "response.data.getElectricianById");
            return response.data.electrician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const editElectrician = createAsyncThunk(
    'electrician/edit',
    async (data, { dispatch, rejectWithValue }) => {
        
        try {
            const { _id, MultipleImages, electricianImage, electricianDetails, ...rest } = data;

            const formData = new FormData();
            formData.append('_id', _id);

            // Append all PaymentDetails, including existing ones

            formData.append('MultipleImages', JSON.stringify(MultipleImages));

            if (Array.isArray(electricianDetails) && electricianDetails.length > 0) {
                electricianDetails.forEach((detail, index) => {
                    const formattedDetail = formatElectricianDetail(detail);

                    Object.keys(formattedDetail).forEach(key => {
                        if (formattedDetail[key] !== null && formattedDetail[key] !== '') {
                            formData.append(`electricianDetails[${index}][${key}]`, formattedDetail[key]);
                        }
                    });

                    const formattedDetailSecond = formatElectricianDetail(detail);
                    Object.keys(formattedDetailSecond).forEach(key => {
                        if (formattedDetailSecond[key] !== null && formattedDetailSecond[key] !== '') {
                            formData.append(`electricianDetailsSecond[${index}][${key}]`, formattedDetailSecond[key]);
                        }
                    });
                });
            } else {
                formData.append('electricianDetails', null);
            }

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (electricianImage) {
                electricianImage.forEach((file, index) => {
                    if (file instanceof File) {
                        // New file
                        formData.append('electricianImage', file);
                        formData.append(`electricianImageIndex_${formData.getAll('electricianImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        // Existing file path
                        formData.append(`ExistingelectricianImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.put(`${BASE_URL}/updateElectrician/${_id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data.electrician);
            dispatch(getElectrician());
            return response.data.electrician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const formatElectricianDetail = (detail) => ({
    electricianCatogory: detail.electricianCatogory || null,
    electricianSubCatogory: detail.electricianSubCatogory ? detail.electricianSubCatogory.trim() : null,
    electricianProductName: detail.electricianProductName ? detail.electricianProductName.trim() : null,
    electricianQty: detail.electricianQty || null,
});

export const updateElectricianStatus = createAsyncThunk(
    'electrician/updateElectricianStatus',
    async ({ ids, submitDate }, { dispatch, rejectWithValue }) => {
        try {

            
            const response = await axiosInstance.post(`${BASE_URL}/updateElectricianStatus`, { ids, submitDate }, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            
            // dispatch(getElectrician());
            return response.data.electrician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const getInstallerInEle = createAsyncThunk(
    'InstallerInEle/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getInstallerInEle', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.assign;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getcategoryInEle = createAsyncThunk(
    'EleCategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/geteleCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getsubcategoryInEle = createAsyncThunk(
    'ElesubCategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/geteleSubCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getproductInEle = createAsyncThunk(
    'Eleproduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/geteleProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);



const electricianSlice = createSlice({
    name: 'electrician',
    initialState: initialStateElectrician,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getElectrician.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Electricians...';
            })
            .addCase(getElectrician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Electricians fetched successfully';
                state.Electrician = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getElectrician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Electricians';
            })
            .addCase(addElectrician.pending, (state) => {
                state.loading = true;
                state.message = 'Adding Electricians...';
            })
            .addCase(addElectrician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Electrician.push(action.payload);
                state.message = action.payload?.message || 'Electrician added successfully';
            })
            .addCase(addElectrician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Electrician';
            })
            .addCase(deleteElectrician.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Electrician...';
            })
            .addCase(deleteElectrician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Electrician = state.Electrician.filter((electrician) => electrician._id !== action.payload);
                state.message = action.payload?.message || 'Electrician deleted successfully';
            })
            .addCase(deleteElectrician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Electrician';
            })
            .addCase(editElectrician.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Electrician...';
            })
            .addCase(editElectrician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.Electrician)) {
                    state.Electrician = state.Electrician.map(electrician =>
                        electrician._id === action.payload?._id ? action.payload : electrician
                    );
                }
                state.message = 'Electrician updated successfully';
            })
            .addCase(editElectrician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Electrician';
            })
            .addCase(getElectricianById.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Electrician...';
            })
            .addCase(getElectricianById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Electrician fetched successfully';
                state.Electrician = action.payload;
            })
            .addCase(getElectricianById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Electrician';
            })
            .addCase(updateElectricianStatus.pending, (state) => {
                state.loading = true;
                state.message = 'Updating Electrician Status...';
            })
            .addCase(updateElectricianStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Electrician status updated successfully';
                // dispatch(getFabricator());
            })
            .addCase(updateElectricianStatus.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Electrician status';
            })
            .addCase(getInstallerInEle.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Electricians...';
            })
            .addCase(getInstallerInEle.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Electricians fetched successfully';
                state.assign = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getInstallerInEle.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Electricians';
            })
            .addCase(getcategoryInEle.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getcategoryInEle.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.category = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getcategoryInEle.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getsubcategoryInEle.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getsubcategoryInEle.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.subCategory = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getsubcategoryInEle.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getproductInEle.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getproductInEle.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.products = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getproductInEle.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
    }
});

export default electricianSlice.reducer;